import firebase from "@firebase/app";
import 'firebase/firestore';

const initialState = () => ({
  allBanners: [], // for admin to controle
  appBanners: [], // inorder to display in front
});

const state = initialState();

const getters = {
  allBanners: (state) => state.allBanners,
  appBanners: (state) => state. appBanners,
};

const mutations = {
  setAllBanners(state, banners) {
    state.allBanners = banners;
  },
  addBanner(state, banner) {
    state.allBanners.push(banner);
  },
  deleteBanner(state, bannerId) {
    state.allBanners = state.allBanners.filter(banner => banner.id !== bannerId);
  },
  updateBanner(state, { bannerId, updatedBanner }) {
    const index = state.allBanners.findIndex(banner => banner.id === bannerId);
    if (index !== -1) {
      state.allBanners[index] = { ...state.allBanners[index], ...updatedBanner };
    }
  },
  setAppBanners(state, banners) {
    state.appBanners = banners;
  },
  addAppBanner(state, banner) {
    state.appBanners.push(banner);
  },
  deleteAppBanner(state, bannerId) {
    state.appBanners = state.appBanners.filter(banner => banner.id !== bannerId);
  },
  RESET_STATE(state) {
    Object.assign(state, initialState());
  },
};

const actions = {
  async getAllBanners({ commit }) {
    const db = firebase.firestore();
    const bannersSnapshot = await db.collection("facts_app_banners")
                                    .orderBy("createdAt", "desc")
                                    .get();
    // const banners = bannersSnapshot.docs.map(doc => ({ id: doc.id, ...doc.data() }));
    const banners = bannersSnapshot.docs.map(doc => ({ 
      id: doc.id, 
      ...doc.data(),
      // validFrom: doc.data().validFrom?.toDate(),
      // validTill: doc.data().validTill?.toDate(),
    }));
    commit("setAllBanners", banners);
  },

  async addBanner({ commit }, bannerData) {
    const db = firebase.firestore();
    const now = firebase.firestore.Timestamp.now();
    const bannerWithTimestamp = {
      ...bannerData,
      createdAt: now,
      validFrom: firebase.firestore.Timestamp.fromDate(new Date(bannerData.validFrom)),
      validTill: firebase.firestore.Timestamp.fromDate(new Date(bannerData.validTill)),
    };
    const docRef = await db.collection("facts_app_banners").add(bannerWithTimestamp);
    commit("addBanner", { id: docRef.id, ...bannerWithTimestamp });
    // dispatch("updateAppBanners");
  },

  async deleteBanner({ commit }, bannerId) {
    const db = firebase.firestore();
    await db.collection("facts_app_banners").doc(bannerId).delete();
    commit("deleteBanner", bannerId);
    // dispatch("updateAppBanners");
  },

  async updateBanner({ commit }, { bannerId, updatedBanner }) {
    const db = firebase.firestore();
    const bannerWithTimestamp = {
      ...updatedBanner,      
      validFrom:  updatedBanner?.validFrom ? firebase.firestore.Timestamp.fromDate(new Date(updatedBanner.validFrom)) : '',
      validTill:  updatedBanner?.validTill ?  firebase.firestore.Timestamp.fromDate(new Date(updatedBanner.validTill)): '',
    };
    await db.collection("facts_app_banners").doc(bannerId).update(bannerWithTimestamp);
    commit("updateBanner", { bannerId, bannerWithTimestamp });
    // dispatch("updateAppBanners");
  },
  
  async updateAppBanners({ commit }) {
    const db = firebase.firestore();
    const now = firebase.firestore.Timestamp.now();
    const bannersSnapshot = await db.collection("facts_app_banners")
      .where("isActive", "==", true)
      .where("validFrom", "<=", now)
      .where("validTill", ">=", now)
      .orderBy("validFrom", "desc")
      .get();
    const banners = bannersSnapshot.docs.map(doc => ({ 
      id: doc.id, 
      ...doc.data(),
      validFrom: doc.data().validFrom.toDate(),
      validTill: doc.data().validTill.toDate(),
    }));
    commit("setAppBanners", banners);
  },
  subscribeToBanners({ dispatch }) {
    const db = firebase.firestore();
    return db.collection("facts_app_banners")
      .onSnapshot(() => {
        dispatch("updateAppBanners");
      });
  },
  // subscribeToBanners({ commit }) {
  //   const db = firebase.firestore();
  //   return db.collection("facts_app_banners")
  //           .where("isActive", "==", true)
  //           .orderBy("createdAt", "desc")
  //           .onSnapshot((snapshot) => {
  //           const banners = [];
  //           snapshot.docs.forEach(doc => {
  //               banners.push({ id: doc.id, ...doc.data() });
  //           });
  //       commit("setAppBanners", banners);
  //   });
  // },
};

export default {
    namespace: true,
    state,
    getters,
    actions,
    mutations,
};